import React from "react"

var Clone = {

  /**
  * Performs a deep JSON clone
  *
  * @param {object} obj
  * @returns {object} clone
  */
  clone: function (obj) {
    return JSON.parse(JSON.stringify(obj));
  }

};

module.exports = Clone;

export default Clone
